import { ProductConfigState } from "@husky-hrc/Framework/Store/Data/ProductConfig/ProductConfigState";
import { ProductConfigModel } from "@husky-hrc/Framework/Types/ApiModel";
import Constants from "@husky-hrc/Utilities/Constants";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { assignById } from "@insite/client-framework/Store/Data/DataState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: ProductConfigState = {
    isLoading: {},
    idByProduct: {},
    byId: {},
    dataViews: {},
};

const reducer = {} as any;

reducer[Constants.Actions.BeginLoadProductConfig] = (draft: Draft<ProductConfigState>, action: { id: string }) => {
    draft.isLoading[action.id] = true;
    delete draft.selectedProductInfo;
};

reducer[Constants.Actions.CompleteLoadProductConfig] = (
    draft: Draft<ProductConfigState>,
    action: { model: ProductConfigModel; id?: string; productInfo?: ProductInfo },
) => {
    if (action.id) {
        draft.idByProduct[action.id] = action.model.id;
        delete draft.isLoading[action.id];
    }
    assignById(draft, action.model);
    draft.selectedProductInfo = action.productInfo;
};

reducer[Constants.Actions.BeginUpdateProductConfig] = (draft: Draft<ProductConfigState>, action: { id: string }) => {
    draft.isLoading[action.id] = true;
};

reducer[Constants.Actions.CompleteUpdateProductConfig] = (
    draft: Draft<ProductConfigState>,
    action: { model: ProductConfigModel; id?: string },
) => {
    if (action.id) {
        draft.idByProduct[action.id] = action.model.id;
        delete draft.isLoading[action.id];
    }
    assignById(draft, action.model);
};

reducer[Constants.Actions.RemoveProductConfig] = (draft: Draft<ProductConfigState>, action: { productId: string }) => {
    delete draft.idByProduct[action.productId];
    delete draft.selectedProductInfo;
};

const productConfigReducer = createTypedReducerWithImmer(initialState, reducer);

// This line is important as it adds the reducer to the reducers collection on the Store.
(reducers as any).productConfig = productConfigReducer;
